import {TabsProps} from "antd";
import React from "react";
import {tabKeys} from "types/enums";
import Role from "./new/Role/Role";
import Api from "./new/Api/Api";
import Function from "./new/Function/Function";
import RoleFunction from "./old/Role-Function/Role-Function";
import ApiRole from "./old/Api-Role/ApiRole";
import Account from "./new/Account/Account";
import Branch from "./new/Branch/Branch";
const items: TabsProps["items"] = [
  {
    key: tabKeys.AUTHORIZATION.ACCOUNT,
    label: "Tài khoản",
    children: <Account></Account>,
  },
  {
    key: tabKeys.AUTHORIZATION.BRANCH,
    label: "Chi nhánh",
    children: <Branch></Branch>,
  },
  {
    key: tabKeys.AUTHORIZATION.ROLE,
    label: "Role",
    children: <Role></Role>,
  },
  {
    key: tabKeys.AUTHORIZATION.FUNCTION,
    label: "Chức năng",
    children: <Function></Function>,
  },
  {
    key: tabKeys.AUTHORIZATION.API,
    label: "API",
    children: <Api></Api>,
  },
  // {key: tabKeys.AUTHORIZATION.ROLE, label: "Role", children: <Role></Role>},
  // {key: tabKeys.AUTHORIZATION.API, label: "API", children: <Api></Api>},
  // {
  //   key: tabKeys.AUTHORIZATION.FUNCTION,
  //   label: "Chức năng",
  //   children: <Function></Function>,
  // },
  // {
  //   key: tabKeys.AUTHORIZATION.ROLE_CHUCNANG,
  //   label: "Role - Chức năng",
  //   children: <RoleFunction></RoleFunction>,
  // },
  // {
  //   key: tabKeys.AUTHORIZATION.API_ROLE,
  //   label: "API - Role",
  //   children: <ApiRole></ApiRole>,
  // },
];
export {items};
